import { errorFilledToastOptions, ibanLengths } from "../../../../constants"
import { lang } from "../../../../constants/languages"
import { PaymentMethod } from "../../../../types"
import { toast } from "react-toastify"

const checkIbanValidity = (iban: string) => {
  const cleanedIban = iban.replace(/\s+/g, "")

  if (cleanedIban.length < 2) return lang.account.payment_methods.payment_form.error.short_iban

  const firstTwo = cleanedIban.slice(0, 2)

  const allowedLength = ibanLengths[firstTwo]

  if (!allowedLength) return lang.account.payment_methods.payment_form.error.country_code_invalid

  if (allowedLength > cleanedIban.length) return lang.account.payment_methods.payment_form.error.short_iban

  if (allowedLength < cleanedIban.length) return lang.account.payment_methods.payment_form.error.long_iban

  const rearranged = cleanedIban.slice(4) + cleanedIban.slice(0, 4)

  let numericIban = ""
  for (const char of rearranged) {
    const code = char.charCodeAt(0)
    numericIban += code >= 65 && code <= 90 ? code - 55 : char
  }
  let remainder = numericIban
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9)
    remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length)
  }

  if (!(parseInt(remainder, 10) % 97 === 1)) return lang.account.payment_methods.payment_form.error.invalid_iban

  return null
}

const paymentMethodValidator = (formValues: PaymentMethod) => {
  const errors: any = {}

  if (!formValues.bankName) {
    errors.bankName = lang.account.payment_methods.payment_form.error.bank_name_blank
    toast.error(lang.account.payment_methods.payment_form.error.bank_name_blank, errorFilledToastOptions)
  }
  if (!formValues.accountHolderName) {
    errors.accountHolderName = lang.account.payment_methods.payment_form.error.account_holder_name_blank
    toast.error(lang.account.payment_methods.payment_form.error.account_holder_name_blank, errorFilledToastOptions)
  }
  if (!formValues.iban) {
    errors.iban = lang.account.payment_methods.payment_form.error.iban_blank
    toast.error(lang.account.payment_methods.payment_form.error.iban_blank, errorFilledToastOptions)
  } else if (formValues.iban) {
    const errorMessage = checkIbanValidity(formValues.iban)
    if (errorMessage !== null) {
      errors.iban = errorMessage
      toast.error(errorMessage, errorFilledToastOptions)
    }
  }
  if (!formValues.currency) {
    errors.currency = lang.account.payment_methods.payment_form.error.currency_select
    toast.error(lang.account.payment_methods.payment_form.error.currency_select, errorFilledToastOptions)
  }

  return errors
}

export default paymentMethodValidator
